import { CustomButton } from "#components/ui/CustomButton.tsx";
import { useGetQuotaUsageSuspenseQuery } from "#features/quotas/api/useGetQuotaUsageSuspenseQuery.ts";
import { QuotaUsageCircularProgress } from "#features/quotas/components/QuotaUsageCircularProgress.tsx";
import { QuotaUsagePopover } from "#features/quotas/components/QuotaUsagePopover.tsx";
import { useSharedTranslation } from "#hooks/useSharedTranslation.ts";
import { useSubscriptionTier } from "#hooks/useSubscriptionTier.ts";
import {
    type BorderValue,
    type ColorValue,
    Content,
    Inline,
    Popover,
    PopoverTrigger,
    Text,
    useColorSchemeValue
} from "@hopper-ui/components";
import "./QuotaUsage.css";
import "./QuotaUsage.dark.css";

export const QuotaUsage = () => {
    const { tShared } = useSharedTranslation();
    const { data: { quotaUsage: { remaining, currentUsage, limit } } } = useGetQuotaUsageSuspenseQuery();
    const { isPremium } = useSubscriptionTier();

    const color = useColorSchemeValue(
        "core_orchid-bloom-700",
        "neutral-weak"
    ) as ColorValue;

    const border = useColorSchemeValue(
        "core_orchid-bloom-75",
        "core_rock-500"
    ) as BorderValue;

    const progress = limit > 0 ? (currentUsage / limit) * 100 : 0;

    if (isPremium) {
        return null;
    }

    return (
        <PopoverTrigger>
            <CustomButton
                borderRadius="pill"
                paddingX="inset-sm"
                paddingY="inset-xs"
                minHeight="core_320"
                border={border}
                className="wai-quota-usage-button"
            >
                <Inline gap="inline-sm">
                    <QuotaUsageCircularProgress progress={progress} />
                    <Text
                        size="xs"
                        color={color}
                        fontFamily="overline"
                        textTransform="uppercase"
                    >
                        {tShared("quotaUsage", { count: remaining })}
                    </Text>
                </Inline>
            </CustomButton>
            <Popover>
                <Content>
                    <QuotaUsagePopover
                        currentUsage={currentUsage}
                        progress={progress}
                        limit={limit}
                        remaining={remaining}
                    />
                </Content>
            </Popover>
        </PopoverTrigger>
    );
};
